import ACTION from './creator'

export const SettingsUserParam = (state = { paramData: null, message: '' }, { type, payload }) => {
  switch (type) {
    case ACTION.USER_PARAM.PENDING:
    case ACTION.USER_PARAM.SUCCESS:
    case ACTION.USER_PARAM.FAILURE:
      return payload
    default:
      return state
  }
}
